var durations = {
  100: '100ms',
  150: '150ms',
  200: '200ms',
  250: '250ms',
  300: '300ms',
  500: '500ms'
};
var eases = {
  linear: 'cubic-bezier(0, 0, 1, 1)',
  primary: 'cubic-bezier(0.5, 0, 0, 1)',
  easeIn: 'cubic-bezier(0.32, 0, 0.67, 0)',
  easeOut: 'cubic-bezier(0.33, 1, 0.68, 1)'
};
var interaction = {
  duration: durations[100],
  easing: eases.linear
};
export var transitions = {
  interaction: interaction,
  durations: durations,
  eases: eases
};